export function isEmpty(object?: Object): boolean {
  return Boolean(object) && Boolean(Object.keys(object!).length);
}
